import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from "./Header";
import Sider from "./Sidebar";

import { Layout as AntLayout } from 'antd';
import './style.scss';

const AppLayout: React.FC = () => {
  return (
    <AntLayout className='v-layout'>
      <Sider />

      <AntLayout className='v-layout--main'>
        <Header />

        <Outlet />
      </AntLayout>
    </AntLayout>
  );
}

export { Page } from './Page';
export { RightSidebar } from './RightSidebar';
export default AppLayout;
